import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ModalStyles } from "components/Common/styles.js";
import { languageService } from "../../Language/language.service";
import PropTypes from "prop-types";
import { CommonModalStyle } from "style/basic/commonControls";
import { themeService } from "theme/service/activeTheme.service";

const CommonModalMultiPage = (props) => {
  const { isOpen, headerText, className, modalStyle, pages, currentPage, onPageChange } = props;

  const page = pages[currentPage] || {};

  return (
    <Modal
      contentClassName={themeService({
        default: className,
        retro: "retroModal " + className,
        electric: "electricModal " + className,
      })}
      isOpen={isOpen}
      style={modalStyle || { maxWidth: "50vw" }}
    >
      <ModalHeader style={themeService(CommonModalStyle.header)}>{languageService(headerText)}</ModalHeader>

      <ModalBody className="scrollbar" style={themeService(CommonModalStyle.body)}>
        {page.content}
      </ModalBody>

      <ModalFooter style={themeService(CommonModalStyle.footer)}>
        {page.footer &&
          page.footer({
            currentPage,
            onPageChange,
            totalPages: pages.length,
          })}
      </ModalFooter>
    </Modal>
  );
};

CommonModalMultiPage.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  headerText: PropTypes.string,
  className: PropTypes.string,
  modalStyle: PropTypes.object,
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.node,
      footer: PropTypes.func, // gets { currentPage, onPageChange, totalPages }
    }),
  ).isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default CommonModalMultiPage;



// WEBPACK FOOTER //
// ./src/components/Common/commonModalMultiPage.jsx